export const defaultServerError = 'Произошла ошибка при работе с сервером';
